import request from './request'

/**
 * === === === === === === = 直播 === === === === === === =
 *  */

//获取直播详情   /admin/live?id=1
export function _getLive(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/live',
  })
  return request(config)
}

//更新ppt    /admin/live/updateppt?id=1
export function _updateppt(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/live/updateppt',
  })
  return request(config)
}

//禁言模式    /admin/live/forbidden?course_id=1  form-data：comment_id=1
export function _liveForbidden(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/forbidden',
  })
  return request(config)
}

//禁言用户    /admin/live/black?course_id=1  form-data：user_id=1
export function _liveBlack(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/black',
  })
  return request(config)
}

//撤回    /admin/live/rest?course_id=1  form-data：comment_id=1
export function _liveRest(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/rest',
  })
  return request(config)
}

//发布消息    /admin/live/im?course_id=1
export function _sendLiveIm(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/im',
  })
  return request(config)
}

// 讨论列表   /admin/live/discuss?course_id=1 form-data：page=1&size=30
export function _getLiveDiscuss(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/discuss',
  })
  return request(config)
}

//提问列表    /admin/live/qa?course_id=1 form-data：page=1&size=30
export function _getLiveQa(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/qa',
  })
  return request(config)
}

//讲解列表    /admin/live/class?course_id=1 form-data：page=1&size=30
export function _getLiveClass(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/live/class',
  })
  return request(config)
}


/**
 * === === === === === === = 媒体库 === === === === === === =
 *  */

//媒体库获取    /admin/material/index?course_id=1
export function _getMaterial(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/material/index',
  })
  return request(config)
}

//媒体删除    /admin/material/del?id=1
export function _delMaterial(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/material/del',
  })
  return request(config)
}
